module.exports = __webpack_public_path__ + "static/media/hook-login-background-1.26778661.jpg";